import { createAction } from '@reduxjs/toolkit';

export const AssetActions = {
  getObject: createAction<{ key: string }>('user/GET_OBJECT'),
};
